window.category =
{
    bindFilterForm: function (form)
    {
        var checkboxes = form.querySelectorAll("input[type=checkbox]");

        checkboxes.forEach(function (checkbox)
        {
            checkbox.addEventListener("change", async function (e)
            {
                await submitAjaxForm(form);

                price.asyncPrice();
            });
        });
    },
    clearFiltersAsync: async function ()
    {
        var checkBoxes = document.querySelectorAll("[data-product-filter] input[type='checkbox']");

        for (var checkBox of checkBoxes)
            checkBox.checked = false;

        var filterForm = document.querySelector("form[data-product-filter]");

        await submitAjaxForm(filterForm);

        price.asyncPrice();

        var parameters = new URLSearchParams(window.location.search);
        parameters.delete("params");
        parameters.delete("sf");

        window.history.replaceState({}, document.title, window.location.pathname + "?" + parameters.toString());
    },
    initFilter: function ()
    {
        var filterForm = document.querySelector("form[data-product-filter]");

        if (filterForm)
            category.bindFilterForm(filterForm);
    },
    removeFilter: function (property, value)
    {
        var parameters = new URLSearchParams(window.location.search);

        if (property == "sf")
        {
            var checkBox = document.querySelector(`input[name='StaticFilter'][value='${value}']`);

            if (checkBox)
            {
                checkBox.checked = false;

                // trigger change event
                checkBox.dispatchEvent(new Event("change", { bubbles: true }));
            }

            value = value.toLowerCase();

            var staticFilters = (parameters.get("sf") || "").split(',');
            staticFilters = staticFilters.filter(item => item != value);
            staticFilters = staticFilters.join(',');

            parameters.set("sf", staticFilters);
        }
        else
        {
            var input = document.querySelector(`.filter-list-${property} input[type='hidden'][name$='.Value'][value='${value}']`);
            var parent = null;
            var checkBox = null;

            if (input)
                parent = input.parentNode;

            if (parent)
                checkBox = parent.querySelector("input[type='checkbox']");

            if (checkBox)
            {
                checkBox.checked = false;

                // trigger change event
                checkBox.dispatchEvent(new Event("change", { bubbles: true }));
            }

            var properties = (parameters.get("params") || "").split(';');

            for (var i = 0; i < properties.length; i++)
            {
                var propertyValue = properties[i].split('-');

                if (propertyValue[0] != property)
                    continue;

                var values = propertyValue[1].split(',');

                for (var j = 0; j < values.length; j++)
                {
                    if (values[j] != value)
                        continue;

                    values.splice(j, 1);

                    break;
                }

                if (values.length > 0)
                    properties[i] = property + "-" + values.join(',');
                else
                    properties.splice(i, 1);

                break;
            }

            properties = properties.join(';');

            parameters.set("params", properties);
        }

        window.history.replaceState({}, document.title, window.location.pathname + "?" + parameters.toString());
    },
    updateParamUrl: function ()
    {
        var filterForm = document.querySelector("form[data-product-filter]");

        if (!filterForm)
            return;

        var properties = [];
        var staticFilters = [];

        var checkBoxes = filterForm.querySelectorAll(".form-check");

        checkBoxes.forEach(checkBox =>
        {
            var input = checkBox.querySelector("input[type=checkbox]");

            if (!input.checked)
                return;

            if (input.dataset.static == "true")
            {
                staticFilters.push(input.value.toLowerCase());

                return;
            }

            var propertyId = checkBox.querySelector("input[name$=PropertyId]").value;
            var valueId = checkBox.querySelector("input[name$=Value]").value;

            if (!properties[propertyId])
                properties[propertyId] = [];

            properties[propertyId].push(valueId);
        });

        var params = [];

        for (var propertyId in properties)
        {
            var values = properties[propertyId];
            var joinedValues = values.join(",");

            params.push(propertyId + "-" + joinedValues);
        }

        params = params.join(";");

        var staticFiltersString = staticFilters.join(",");

        var parameters = new URLSearchParams(window.location.search);
        parameters.set("params", params);
        parameters.set("sf", staticFiltersString);

        window.history.replaceState({}, document.title, window.location.pathname + "?" + parameters.toString());
    }
};

document.addEventListener("DOMContentLoaded", function (e)
{
    category.initFilter();
});

//export default productFilter;